import React from 'react';
import { NavLink } from "react-router-dom";

function Responseoperation() {

    return (
        <div className="operation-list">
            <div className="operation-name probe">
                <NavLink to="/http/probe">Probe</NavLink>
            </div>
            <div className="operation-name tokenise">
                <NavLink to="/http/tokenise">Tokenise</NavLink>
            </div>
            <div className="operation-name validate">
                <NavLink to="/http/validate">Validate</NavLink>
            </div>
            <div className="operation-name auth">
                <NavLink to="/http/auth">Authorise</NavLink>
            </div>
            <div className="operation-name authsettle">
                <NavLink to="/http/authsettle">Auth & Settle</NavLink>
            </div>
            <div className="operation-name tokenauth">
                <NavLink to="/http/tokenauth">Token Auth</NavLink>
            </div>
            <div className="operation-name tokensettle">
                <NavLink to="/http/tokensettle">Token Settle</NavLink>
            </div>
            <div className="operation-name tokenauthsettle">
                <NavLink to="/http/tokenauthsettle">Token Auth & Settle</NavLink>
            </div>
            <div className="operation-name voidAuthorise">
                <NavLink to="/http/voidauth">Void Auth</NavLink>
            </div>
            <div className="operation-name checkout">
                <NavLink to="/http/checkout">Embedded</NavLink>
            </div>
            <div className="operation-name consolidated-ui">
                <NavLink to="/http/consolidated-ui">Consolidated UI</NavLink>
            </div>
            <div className="operation-name global-tradeshow">
                <NavLink to="/http/global-tradeshow-solution">Global Tradeshow</NavLink>
            </div>
            <div className="operation-name tokenrefund">
                <NavLink to="/http/tokenrefund">Token Refund</NavLink>
            </div>
        </div>
    );
}

export default Responseoperation;